var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBankOfAmerica = function SvgBankOfAmerica(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "bank-of-america_svg__Calque_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bank-of-america_svg__st1{fill:#0a68b1}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h40v40H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 15.7c.9.4 2 .8 2.9 1.2-3 1.2-6 2.7-8.9 4.4-.9-.5-1.9-.9-2.9-1.4 3-1.7 5.9-3.1 8.9-4.2M12.5 14.3c-3.2 1-6.2 2.4-9.1 3.9.9.4 1.8.7 2.7 1 2.8-1.7 5.8-3 8.9-4.1-.9-.2-1.6-.5-2.5-.8",
    className: "bank-of-america_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8 15.6c-2.5-1.2-5.1-2.3-7.7-3-.9.3-1.9.6-2.7.8 2.7.8 5.4 1.8 7.9 3.1.8-.4 1.7-.7 2.5-.9m4.1-1.3c-2.5-1.1-5.2-2.1-7.9-2.8-.8.2-1.7.4-2.5.6 2.6.8 5.3 1.8 7.8 2.9.8-.2 1.6-.5 2.6-.7m6.5 2.2c-6.3 2.2-12.4 5.2-17.8 9.1 1.3.8 2.6 1.7 4 2.6 5.2-4.1 10.8-7.4 16.9-10-1-.6-2.1-1.1-3.1-1.7M29 14.4c-6.6 1.8-12.8 4.5-18.6 8.3 1.2.7 2.5 1.3 3.8 2 5.6-3.9 11.7-6.8 18.2-8.8-1.2-.4-2.3-1-3.4-1.5",
    style: {
      fill: "#e31b37"
    }
  }));
};
export default SvgBankOfAmerica;